import { createSlice } from '@reduxjs/toolkit';
export const loginSlice = createSlice({
  name: 'login',
  initialState: {
    isLoggedIn: false,
    error: null,
    isLoading: false,
    isSuspending: false,
  },
  reducers: {
    loginRequest: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    loginSuccess: (state) => {
      state.isLoggedIn = true;
      state.isLoading = false;
      state.error = false;
    },
    loginFailure: (state) => {
      state.isLoggedIn = false;
      state.isLoading = false;
      state.error = true;
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.error = null;
    },
    resetLoginError: (state) => {
      state.error = null;
    },
    setSystemSuspending: (state, action) => {
      state.isSuspending = action.payload;
    },
  },
});

export const { loginRequest, loginSuccess, loginFailure, logout, resetLoginError, setSystemSuspending } = loginSlice.actions;

//Selectors
export const selectLogin = (state) => state.login;
export default loginSlice.reducer;